import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { teal, lightBlue } from "@mui/material/colors";
import CardHeader from "@mui/material/CardHeader";
import GenieCopyToClipboard from "../utilities/GenieCopyToClipboard";
// import { useGetTokenQuery } from '../store/services/genieservice';
import { selectResults } from "../store/features/genieSlice";
import GenieTable from "../components/chatbot/GenieTable";
import TableDescription from "../components/chatbot/TableDescription";
import DOMPurify from "dompurify";
// import { useIdToken } from '../hooks/useLogin';

const GeniePage = () => {
  const results = useSelector(selectResults);

  useEffect(() => {
    const chatContainer = document.getElementById("chat-container");
    if (chatContainer) {
      chatContainer.scrollTo({
        top: chatContainer.scrollHeight - chatContainer.clientHeight,
        behavior: "smooth",
      });
    }
  }, [results]);

  return (
    <>
      <Grid
        container
        component={Paper}
        sx={{ backgroundColor: "#f5f5f0", color: "#fff", overflowY: "auto" }}
      >
        <Grid id="chat-container" flex={1} item xs={12} sx={{ height: "80vh" }}>
          <Grid
            item
            xs={11}
            sx={{
              backgroundColor: "#f5f5f5",
              color: "#000",
              textAlign: "left",
              height: "0px",
            }}
          >
            <CardHeader
              avatar={<Avatar sx={{ bgcolor: lightBlue["500"] }}>AI</Avatar>}
              title="Hi, this is DATA chatbot. What would you like to ask today?"
            />
          </Grid>
          {results.map((e: any, index: number) => (
            <Grid container key={index}>
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: "#f5f5f5",
                  color: "#000",
                  textAlign: "left",
                }}
              >
                <CardHeader
                  avatar={<Avatar sx={{ bgcolor: teal[100] }}>H</Avatar>}
                  title={e.question}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: "#f5f5f5",
                  color: "#000",
                  textAlign: "left",
                }}
              >
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: lightBlue["500"] }}>AI</Avatar>
                  }
                />
                <Grid
                  container
                  key={index}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid
                    item
                    xs={11}
                    sx={{
                      backgroundColor: "#f5f5f5", //434654
                      color: "#000",
                      textAlign: "left",
                      px: 1,
                    }}
                  >
                    <div id={index.toString()}>
                      {e?.attachment?.query?.description} <br />
                      <br />
                      {e.type === "content" && e.status === "FAILED" && (
                        <div>{e.error.error}</div>
                      )}
                      {e.type === "content" && e.status === "COMPLETED" && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(e.text.content, {
                              ALLOWED_TAGS: [
                                "b",
                                "i",
                                "em",
                                "strong",
                                "a",
                                "p",
                                "br",
                                "ul",
                                "ol",
                                "li",
                                "div",
                                "span",
                                "h1",
                                "h2",
                                "h3",
                                "h4",
                                "h5",
                                "h6",
                                "table",
                                "thead",
                                "tbody",
                                "tr",
                                "th",
                                "td",
                                "code",
                                "pre",
                              ],
                              ALLOWED_ATTR: [
                                "href",
                                "target",
                                "class",
                                "style",
                              ],
                            }),
                          }}
                          style={{ textAlign: "left" }}
                        />
                      )}
                      {e.type === "response" && e.statement_response && (
                        <div>
                          {e.statement_response.manifest &&
                            e.statement_response.manifest.schema &&
                            e.statement_response.manifest.schema.columns && (
                              <GenieTable
                                columns={e.statement_response.manifest.schema.columns.map(
                                  (column: any) => ({
                                    id: column.name,
                                    label: column.name,
                                    minWidth: 100,
                                    align: "left",
                                    dataType: column.type_text
                                      ?.toLowerCase()
                                      .includes("date")
                                      ? "date"
                                      : column.type_text
                                            ?.toLowerCase()
                                            .includes("int") ||
                                          column.type_text
                                            ?.toLowerCase()
                                            .includes("decimal")
                                        ? "number"
                                        : "string",
                                  }),
                                )}
                                data={
                                  e.statement_response.result?.data_array || []
                                }
                                title="Query Results"
                              />
                            )}
                        </div>
                      )}
                      {e.attachment?.query && (
                        <div style={{ paddingTop: "10px" }}>
                          <TableDescription
                            data={{
                              tables_desc: e?.attachment?.query?.description,
                              sql_explanation: e?.attachment?.query?.query,
                            }}
                          />
                        </div>
                      )}
                      <GenieCopyToClipboard id={index.toString()} result={e} />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export default GeniePage;
